
// src/features/auth/auth.slice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GroupDescriptor } from "@progress/kendo-data-query";
import { IColumn } from '../../types/User/IGridState';


export interface TabState {
    groupSettings: GroupDescriptor[]
    columns: IColumn[] | null;
    newCallThresholdMins?: number;
}

const initialState: TabState = {
    columns: null,
    newCallThresholdMins: undefined,
    groupSettings: [{ field: "Status_Name", dir: "asc" }]
};

const tabSlice = createSlice({
    name: 'tab',
    initialState,
    reducers: {
        setColumns(state, action: PayloadAction<IColumn[]>) {
            state.columns = action.payload;
        },
        setNewCallThresholdMins(state, action: PayloadAction<number>) {
            state.newCallThresholdMins = action.payload;
        },
        setGroupSettings(state, action: PayloadAction<GroupDescriptor[]>) {
            state.groupSettings = action.payload;
        }
    },
});

export const { setColumns, setNewCallThresholdMins, setGroupSettings } = tabSlice.actions;
export default tabSlice.reducer;